exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-size: 1.2em;\n  color: #999;\n  margin-bottom: 0;\n}\n\nh2 {\n  font-size: 2em;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 80px;\n  width: 100%;\n  background-color: #FFFFFF;\n  border-bottom: 1px solid #DDDDDD;\n  z-index: 2;\n}\n\n.header .logo {\n  display: inline-block;\n  height: 60px;\n  margin: 10px 0;\n}\n\n.header .logo > img {\n  display: block;\n  height: 100%;\n  width: auto;\n}\n\n.content-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  padding-top: 80px;\n  background-color: #eeeeee;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 216px;\n  height: 100%;\n  padding-top: 80px;\n  background-color: #11283c;\n}\n\n.main-content-container {\n  width: calc(100% - 216px);\n  margin-left: 216px;\n  padding: 15px 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main